import React from 'react'

import { ReferenceField, TextField, useRecordContext } from 'react-admin'
import { FC } from 'react'

import { Notification } from 'shared/types'

const NotifiableResources: { [key: string]: { resource: string; displayType: string } } = {
  'Formtopia::Form': {
    resource: 'account/:account_id/services/form',
    displayType: 'Form',
  },
}

type NotifiableReferenceFieldProps = {
  record?: Notification
  source: string
  displayType?: boolean
}

const DisplayField: FC<{ source: string; displayType?: boolean; basePath?: string }> = ({ displayType, ...props }) => {
  const record = useRecordContext()

  if (!displayType) return <TextField {...props} />

  const { source } = props

  return (
    <div>
      {record?.[source]} ({NotifiableResources[record?.notifiableClass].displayType})
    </div>
  )
}

export const NotifiableReferenceField: FC<NotifiableReferenceFieldProps> = ({ displayType, ...rest }) => {
  const record = useRecordContext()
  if (!record) return null

  return (
    <ReferenceField
      record={record}
      {...rest}
      source="notifiable.id"
      reference={NotifiableResources[record.notifiable.notifiableClass].resource}
      label="Notify"
      link={false} // TODO: link (difficulty with account scoping. punted for now)
    >
      <DisplayField displayType={displayType} source="name" />
    </ReferenceField>
  )
}
